import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { api } from '../lib/api';
import { useToast } from '../context/ToastContext';
import TelaPublica from '../components/TelaPublica';
import CampoSenha from '../components/CampoSenha';

// Destino do link enviado por e-mail (`/redefinir-senha?token=...`).
export default function RedefinirSenha() {
  const toast = useToast();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [concluido, setConcluido] = useState(false);
  // null = conferindo; true/false = resultado. Sem isso o formulário aparecia mesmo com o link já usado
  const [linkValido, setLinkValido] = useState(null);

  useEffect(() => {
    if (!token) return;
    api
      .post('/auth/validar-token-reset', { token })
      .then((r) => setLinkValido(r.valido))
      .catch(() => setLinkValido(true)); // sem rede: deixa tentar, o servidor decide no envio
  }, [token]);

  async function enviar(e) {
    e.preventDefault();
    // o tamanho mínimo real é o configurado pelo superadmin e conferido pelo servidor (a mensagem dele aparece se não bater)
    if (novaSenha.length < 4) {
      toast.erro('A nova senha é curta demais');
      return;
    }
    if (novaSenha !== confirmacao) {
      toast.erro('A confirmação não bate com a nova senha');
      return;
    }
    setEnviando(true);
    try {
      await api.post('/auth/redefinir-senha', { token, novaSenha });
      setConcluido(true);
    } catch (err) {
      toast.erro(err.message || 'Não foi possível redefinir a senha');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <TelaPublica>
      <h1 className="h5 text-center mb-3">Criar nova senha</h1>
      {!token && (
        <Alert variant="danger">
          Link incompleto. Peça um novo em <Link to="/esqueci-senha">Esqueci minha senha</Link>.
        </Alert>
      )}
      {token && linkValido === null && !concluido && <Spinner animation="border" />}
      {token && linkValido === false && !concluido && (
        <>
          <Alert variant="warning">Este link já foi usado ou expirou. Peça um novo para criar sua senha.</Alert>
          <Button as={Link} to="/esqueci-senha" variant="primary" className="w-100 text-uppercase fw-bold">
            Pedir um novo link
          </Button>
        </>
      )}
      {concluido ? (
        <>
          <Alert variant="success">Senha alterada com sucesso! Agora é só entrar com a nova senha.</Alert>
          <Button as={Link} to="/login" variant="primary" className="w-100 text-uppercase fw-bold">
            Ir para o login
          </Button>
        </>
      ) : (
        token && linkValido === true && (
          <Form onSubmit={enviar}>
            <Form.Group className="mb-3" controlId="redef-nova">
              <Form.Label>Nova senha</Form.Label>
              <CampoSenha value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} required minLength={4} autoFocus />
              <Form.Text muted>Escolha uma senha forte (o mínimo de caracteres é definido pelo administrador do painel).</Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="redef-conf">
              <Form.Label>Confirme a nova senha</Form.Label>
              <CampoSenha value={confirmacao} onChange={(e) => setConfirmacao(e.target.value)} required minLength={4} />
            </Form.Group>
            <Button type="submit" variant="primary" className="w-100 text-uppercase fw-bold" disabled={enviando}>
              {enviando ? <Spinner animation="border" size="sm" /> : 'Salvar nova senha'}
            </Button>
            <div className="text-center mt-3">
              <Link to="/esqueci-senha">Pedir um novo link</Link>
            </div>
          </Form>
        )
      )}
    </TelaPublica>
  );
}
